import { createI18n } from 'vue-i18n';
import { Language } from '@local-utils/const';
import zh_tw from '@/locales/lang/zh_tw.js';
import zh_cn from '@/locales/lang/zh_cn.js';
import en_us from '@/locales/lang/en_us.js';

// 从缓存中获取语言设置，如果没有则使用默认语言
const getSavedLocale = () => {
  try {
    const savedLocale = localStorage.getItem('app-locale');
    // 验证保存的语言是否在支持的语言列表中
    const supportedLocales = [Language.ZH_TW, Language.ZH_CN, Language.EN_US];
    if (savedLocale && supportedLocales.includes(savedLocale)) {
      return savedLocale;
    }
  } catch (error) {
    console.error('Failed to get saved locale:', error);
  }
  // 默认返回繁体中文
  return Language.ZH_TW;
};

const savedLocale = getSavedLocale();

const i18n = createI18n({
  locale: savedLocale,
  fallbackLocale: Language.ZH_TW,
  legacy: false,
  messages: {
    [Language.ZH_TW]: zh_tw,
    [Language.ZH_CN]: zh_cn,
    [Language.EN_US]: en_us,
  },
});

export default i18n;
